<template>
    <ai-grid-virtual-wrapper
        ref="gridVirtualRef"
        routed-view="view-contract-list"
        :meta='meta'
        :custom-context-menu="customContextMenu"
        :set-context="setContext"
        @toolbar-button-click="toolbarButtonClick"
    />
</template>
<script setup>
import {ref} from "vue";
import AiGridVirtualWrapper from '@/components/wrappers/ai-grid-virtual-wrapper.vue';
import {setTabTitle} from "@/layouts/main-layout/components/navigation-bars-data";
import {ContextNames, getDefaultContextGroup, saveContexts} from "@/layouts/main-layout/main-layout-data";
import {useRouter} from "vue-router";

const gridVirtualRef = ref();
const router = useRouter();
const columns = [
    {
        index: 1,
        field: "kod_contragent",
        text: "Код контрагента",
        id: 127,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "number",
        width: 100,
        group_index: null
    },
    {
        index: 2,
        field: "kod_dog",
        text: "Код договора",
        id: 128,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "number",
        width: 100,
        group_index: null
    },
    {
        index: 3,
        field: "nump",
        text: "Номер контрагента",
        id: 129,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 4,
        field: "inn",
        text: "ИНН контрагента",
        id: 130,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 5,
        field: "kpp",
        text: "КПП контрагента",
        id: 131,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 6,
        field: "name",
        text: "Наименование абонента",
        id: 132,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 7,
        field: "ndog",
        text: "Номер договора",
        id: 133,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 8,
        field: "status",
        text: "Статус",
        id: 134,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 9,
        field: "date_start",
        text: "Дата начала договора",
        id: 135,
        parent_id: null,
        data_type: "date",
        format: "dd.MM.yyyy",
        width: 220
    },
    {
        index: 10,
        field: "date_fin",
        text: "Дата прекращения договора",
        id: 136,
        parent_id: null,
        data_type: "date",
        format: "dd.MM.yyyy",
        width: 220
    },
    {
        index: 11,
        field: "date_plan_end",
        text: "Дата планируемого окончания",
        id: 137,
        parent_id: null,
        data_type: "date",
        format: "dd.MM.yyyy",
        width: 220
    },
    {
        index: 12,
        field: "date_prolong",
        text: "Дата пролонгации",
        id: 138,
        parent_id: null,
        data_type: "date",
        format: "dd.MM.yyyy",
        width: 220
    },
    {
        index: 13,
        field: "date_sign",
        text: "Дата подписания контрагентом",
        id: 139,
        parent_id: null,
        data_type: "date",
        format: "dd.MM.yyyy",
        width: 220
    },
    {
        index: 14,
        field: "date_conclusion",
        text: "Дата заключения",
        id: 140,
        parent_id: null,
        data_type: "date",
        format: "dd.MM.yyyy",
        width: 220
    },
    {
        index: 15,
        field: "date_pokaz",
        text: "Дата снятия показаний",
        id: 141,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "number",
        group_index: null,
        width: 220
    },
    {
        index: 16,
        field: "pl_name",
        text: "Плательщик",
        id: 142,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 17,
        field: "gp_name",
        text: "Грузополучатель",
        id: 143,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 18,
        field: "sb_name",
        text: "Сбытовая компания",
        id: 144,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 19,
        field: "dte_name",
        text: "Тип договора",
        id: 145,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 20,
        field: "dog_of_user",
        text: "Личный договор",
        id: 146,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "number",
        width: 100,
        group_index: null
    },
    {
        index: 21,
        field: "es_id",
        text: "Идентификатор внешней системы",
        id: 147,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 22,
        field: "dep_name",
        text: "Отделение",
        id: 148,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 23,
        field: "okved",
        text: "Код ОКВЭД",
        id: 149,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 100,
        group_index: null
    },
    {
        index: 24,
        field: "vdog_name",
        text: "Вид договора",
        id: 150,
        parent_id: null,
        visible: true,
        can_visible_change: true,
        fixed: false,
        data_type: "string",
        width: 880,
        group_index: null
    }
];
const meta = {
    meta_agrs: {
        db_schema_name: 'dog',
        db_view_name: 'mvi_kv_dogovor_reestr',
        key: 'kod_dog'
    },
    columns: columns,
    loadUrl: 'contract./view-contract-list/data/get',
    keyExpr: 'kod_dog',
    // editViewRoutName: 'contract-card-view',
    // createViewRoutName: 'contract-card-view',
    viewId: 'view-contract-list',
    toRemoveToolbarItemsNames: ['choice', 'copy', 'save'],
};

const setContext = async (dataRow) => {
    const orgContextGroup = getDefaultContextGroup(ContextNames.ORG_CONTEXT_GROUP);
    orgContextGroup.contexts.PayerContext = {value: dataRow['kod_contragent'], userText: dataRow['name']};
    orgContextGroup.contexts.DogContext = {value: dataRow['kod_dog'], userText: dataRow['ndog']};
    await saveContexts({nameGroup: ContextNames.ORG_CONTEXT_GROUP, value: orgContextGroup});
};

const customContextMenu = [
    {
        text: 'Открыть карточку договора',
        onItemClick: async e => {
            setTabTitle(`Договор ` + `${e.itemData.rowData.data['ndog']}`);
            await router.push({name: 'contract-card-view', params: {id: e.itemData.rowData.key}});
        },
    },
];

const toolbarButtonClick = async e => {
    if (e.item.component.name === 'edit') {
        const key = gridVirtualRef.value.gridInstance.gridInstance.option('focusedRowKey');
        const rowData = gridVirtualRef.value.gridInstance.gridInstance.option('dataSource').items().find(row => row[meta.keyExpr] === key);
        setTabTitle(`${rowData['ndog']}`);
        await router.push({name: 'contract-card-view', params: {id: key}});
    }
};

</script>
<script>
export default {name: 'view-contract-list'};
</script>
